import { Component, OnInit } from '@angular/core';
import { CommonServiceService } from "../../services/common_service/common-service.service";
import { TranslateService } from '@ngx-translate/core';
import { ModalController } from "@ionic/angular";


@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent implements OnInit {

  bookOfRules: any = [];
  bookOfRulesItem: any = [];
  ruleSet: any = [];
  shownRule: any;
  isHidden = true;

  constructor(private commonServiceService: CommonServiceService, translate: TranslateService,public modalController: ModalController,) {
    //translate.use('en');
   }

  ngOnInit() {
    this.commonServiceService.getRules().subscribe(
      (data) => {
        this.bookOfRules = data;
        this.setRules();
      },
      (error) => {
        //console.log(error);
      }
    );
  }

  setRules() {
    for (let i = 0; i < this.bookOfRules.payload.length; i++) {
      this.ruleSet[i] = {
        id: this.bookOfRules.payload[i].id,
        ruleDesc: this.bookOfRules.payload[i].ruleDesc,
        items: [],
      };
    }
  }

  toggleRule($event, rule) {
    this.shownRule = '';
    //console.log("This is 1 ::", this.shownRule);
    if (this.isRuleShown(rule)) {
      //console.log("This is 2 ::", this.shownRule);
      this.shownRule = null;
    } else {
      this.shownRule = rule;
      //console.log("This is 3 ::", this.shownRule);
      this.commonServiceService.getRuleItem(rule.id).subscribe(
        (data) => {
          this.bookOfRulesItem = data;
          // SetRulesItem
          rule.items = [];
          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < this.bookOfRulesItem.payload.length; i++) {
            rule.items.push(this.bookOfRulesItem.payload[i].ruleDesc);
          }
        },
        (error) => {
          //console.log(error);
        }
      );
    }
  }

  isRuleShown(rule) {
    //console.log("This is 4 ::", this.shownRule);
    return this.shownRule === rule;
  }

  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }



}
